module.exports = __webpack_public_path__ + "img/color2.d75822fd.jpg";